/**
 * Slow Plate icon set: 24px grid, 1.25 stroke, round ends. Drawn for this
 * system rather than pulled from a library, so the line weight matches the
 * hairlines everywhere else on the page.
 */
interface IconProps {
  className?: string;
}

const cls = (extra?: string) => `sp-ic${extra ? ` ${extra}` : ''}`;

export const PhoneIcon = ({ className }: IconProps) => (
  <svg className={cls(className)} viewBox="0 0 24 24" aria-hidden="true">
    <path d="M8.2 3.8H5.6c-.9 0-1.6.8-1.5 1.7.7 7.4 6.9 13.6 14.3 14.3.9.1 1.7-.6 1.7-1.5v-2.6c0-.5-.3-.9-.8-1l-3-.8c-.4-.1-.8 0-1 .3l-1.5 1.6c-2.4-1.1-4.4-3.1-5.5-5.5l1.6-1.5c.3-.3.4-.7.3-1l-.8-3c-.1-.5-.5-.8-1-.8z" />
  </svg>
);

export const ChiliIcon = ({ className }: IconProps) => (
  <svg className={cls(`is-hot${className ? ` ${className}` : ''}`)} viewBox="0 0 24 24" aria-hidden="true">
    <path className="body" d="M15.6 8.2c-1.6-.3-3.1.6-3.7 2.1-1.4 3.4-3.9 6.3-7.4 8 4.9 1.7 10.3-.4 12.4-5 .8-1.7.5-3.6-1.3-5.1z" />
    <path className="stem" d="M15.6 8.2c.3-1.6 1.2-3 2.6-3.7M15.6 8.2c1.1-.3 2.3 0 3 .8" />
  </svg>
);

export const VegIcon = ({ className }: IconProps) => (
  <svg className={cls(className)} viewBox="0 0 24 24" aria-hidden="true">
    <rect x="3.5" y="3.5" width="17" height="17" />
    <path d="M8 16c0-5 3-8 8.5-8.5C16 13 13 16 8 16z" />
    <path d="M8 16l5-5" />
  </svg>
);

/** The logo's sun over the river, reduced to a line drawing. */
export const SunIcon = ({ className }: IconProps) => (
  <svg className={cls(className)} viewBox="0 0 30 30" aria-hidden="true">
    <circle cx="15" cy="13" r="7" />
    <path d="M3 20h24" />
    <path d="M7 24c2.7-1.4 5.3-1.4 8 0s5.3 1.4 8 0" opacity=".6" />
  </svg>
);

export const CloseIcon = ({ className }: IconProps) => (
  <svg className={cls(className)} viewBox="0 0 24 24" aria-hidden="true">
    <path d="M6.5 6.5l11 11M17.5 6.5l-11 11" />
  </svg>
);

export const Arrow = () => (
  <svg className="sp-arr" viewBox="0 0 34 12" aria-hidden="true">
    <path d="M0 6h32" />
    <path d="M27 1l5 5-5 5" />
  </svg>
);
